import { render, staticRenderFns } from "./Oxigeno.vue?vue&type=template&id=fef50e32"
import script from "./Oxigeno.vue?vue&type=script&lang=js"
export * from "./Oxigeno.vue?vue&type=script&lang=js"
import style0 from "./Oxigeno.vue?vue&type=style&index=0&id=fef50e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports